import ErpAnimatedLogo from "src/assets/animated-exonn-logo2.svg?react";
import type { SVGProps } from "react";

export const AnimatedLogo = (props: SVGProps<SVGSVGElement>) => {
  return <ErpAnimatedLogo {...props} />;
};
